import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/clusters')({
  // Owns the whole clusters subtree (overview, scale, inference, api-keys, …); children inherit.
  staticData: {
    domain: 'cluster',
  },
});
